import React, { useState } from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { API_BASE_URL } from '../config';

const Page = styled.div`max-width: 640px; margin: 40px auto; padding: 0 20px;`;
const Field = styled.textarea`width: 100%; min-height: 120px; padding: 12px; border: 1px solid #ddd; border-radius: 8px; margin-bottom: 16px;`;
const Btn = styled.button`background: #ff6b35; color: #fff; border: none; padding: 12px 24px; border-radius: 8px; cursor: pointer;`;

const BecomeExpert = () => {
  const { isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const [about, setAbout] = useState('');
  const [credentials, setCredentials] = useState('');
  const [msg, setMsg] = useState('');
  const [loading, setLoading] = useState(false);

  if (!isAuthenticated()) {
    return (
      <Page>
        <h1>Стать экспертом</h1>
        <p><button type="button" onClick={() => navigate('/login')}>Войдите</button>, чтобы подать заявку.</p>
      </Page>
    );
  }

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMsg('');
    try {
      const token = localStorage.getItem('token');
      const res = await fetch(`${API_BASE_URL}/expert-applications`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify({ about, credentials, attachments: [] })
      });
      const d = await res.json();
      if (res.ok) {
        setMsg('Заявка отправлена. Администратор рассмотрит её в ближайшее время.');
        setAbout('');
        setCredentials('');
      } else {
        setMsg(d.message || 'Ошибка отправки');
      }
    } catch {
      setMsg('Ошибка сети');
    }
    setLoading(false);
  };

  return (
    <Page>
      <h1>Стать экспертом</h1>
      <p>Расскажите о себе и своей экспертности. После одобрения вы сможете создавать подборки товаров.</p>
      <form onSubmit={submit}>
        <label>О себе (развёрнуто) *</label>
        <Field value={about} onChange={e => setAbout(e.target.value)} required />
        <label>Регалии, стаж, награды *</label>
        <Field value={credentials} onChange={e => setCredentials(e.target.value)} required />
        <Btn type="submit" disabled={loading}>{loading ? 'Отправка...' : 'Отправить заявку'}</Btn>
      </form>
      {msg && <p style={{ marginTop: 16, color: msg.includes('отправлена') ? 'green' : '#c00' }}>{msg}</p>}
    </Page>
  );
};

export default BecomeExpert;
